module.exports = __webpack_public_path__ + "img/bg_court_01.16500288.jpg";